import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { useNavigate } from 'react-router-dom';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import Fetch from '../../../../core/util/core/Fetch';

function List() {
    const profileFilter = chooseProfileFilter();
    const navigate = useNavigate();

    const pathFrontEnd = '/entityemployees/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'entities/getall',
        endpointDelete: `${config.endpoints.backend}entityemployees/delete`,
    }

    let list = {
        labelTitle: 'Lista de Empregados',
        labelTitleButtonAdd: 'Importar',
        fieldsShowOnDelete: [''],
        showPrintButtons: true,
        canEdit: false,
        canView: false,
        canDelete: false,
        viewActionColumn: false,
        filter: {
            ...profileFilter,
            hasEmployees: true
        },
        columns: [
            {
                name: 'cnpj',
                label: 'CNPJ'
            },
            {
                name: 'corporate_name',
                label: 'Razão Social'
            },
            {
                name: 'fantasy_name',
                label: 'Nome Fantasia'
            }
        ],
        columnsButtons: [
            {
                buttons: [
                    {
                        label: 'Empregados',
                        icon: 'fas fa-eye',
                        onClick: async item => {
                            navigate(`/entityemployees/list/${item.id}`)
                        },
                        width: '10%'
                    }
                ]
            }
        ],
        buttonsListContainer: [
            {
                name: 'files_entity_employees',
                class: 'btn btn-secondary',
                label: 'Importações',
                tooltipLabel: 'Verificar importações',
                callback: async () => {
                    navigate(`/entityemployees/files`)
                }
            }
        ],
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                buttons={list.buttonsListContainer}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
